import React, { useEffect, useState } from "react";
import { apiWrapper } from "../../apis/CommonApi";
import * as communityApi from "../../apis/CommunityApi";
import PageHeader from "../../components/PageHeader";
import { getDateTime } from "../../utils/date";
import { useNavigate, useParams } from "react-router-dom";
import { API_HOST } from "../../Constants";

export default function NoticeDetailComponent() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [dataSource, setDataSource] = useState(null);

    useEffect(() => {
        apiWrapper(async () => {
            const { status, data } = await communityApi.getNoticePost(id);
            if (status === true) {
                setDataSource(data);
            } else {
                alert(`${data}`);
            }
        });
    }, []);

    const handleDownloadFile = async (item) => {
        //첨부파일 URL -> Blob 변환
        try {
            const response = await fetch(API_HOST + item.file);
            if (!response.ok) {
                throw new Error(`${response.status}`);
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = item.originalFilename;
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error("첨부파일 URL을 Blob 객체로 변환 실패 : ", error)
        }
    }

    return (
        <section class="mbSection MISection">
            <PageHeader isBlack={false} title="공지사항 상세" isUseMenu={false} />
            {dataSource && (
                <div class="container pb-40">
                    <div class="input-wrap input-join-wrap">
                        <div class="input-item">
                            <p class="input-title">제목</p>
                            <div class="input-inner-wrap">
                                <input
                                    class="defaultInput readonlyInput"
                                    type="text"
                                    value={dataSource.title}
                                    readonly
                                />
                            </div>
                        </div>
                        <div class="input-item">
                            <p class="input-title">내용</p>
                            <div class="input-inner-wrap">
                                <textarea
                                    class="defaultTextarea readonlyTextarea"
                                    value={dataSource.content}
                                    readonly
                                />
                            </div>
                        </div>
                        <div class="input-item">
                            <p class="input-title">첨부파일</p>
                            <div class="file-upload-wrap">
                                {dataSource.attachments.length > 0 ?
                                    dataSource.attachments.map((item, index) => (
                                        <div class="file-name" onClick={() => handleDownloadFile(item)}>
                                            <span id="fileName">
                                                {item.originalFilename}
                                            </span>
                                            <button type="button">
                                                <i class="x-icon"></i>
                                            </button>
                                        </div>
                                    )) : (
                                        <span>-</span>
                                    )}
                            </div>
                        </div>
                        <div class="input-item">
                            <p class="input-title">작성자</p>
                            <div class="input-inner-wrap">
                                <input
                                    class="defaultInput readonlyInput"
                                    type="text"
                                    value={dataSource.author}
                                    readonly
                                />
                            </div>
                        </div>
                        <div class="input-item">
                            <p class="input-title">등록일시</p>
                            <div class="input-inner-wrap">
                                <input
                                    class="defaultInput readonlyInput"
                                    type="text"
                                    value={getDateTime(new Date(dataSource.createdDate))}
                                    readonly
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
}
